<app-giftcard-list-element *ngFor="let giftcard of giftCardProducts" [price]="giftcard.price"
  [title]="giftcard.price + ' ' + ('current_currency' | translate)" (click)="onClick(giftcard.id)"
  class="col-12 col-sm-5 col-md-4 pb-4">
</app-giftcard-list-element>

<ng-container *ngFor="let category of categories;">
  <ng-container *ngIf="getImageGiftCardProducts(category.id) as products">
    <app-shop-products *ngIf="products && products.length" class="col-12" [products]="products" [title]="category.name"
      [hideProductName]="hideGiftCardProductName" (productClick)="onProductClick($event)"></app-shop-products>
  </ng-container>
</ng-container>

<div *ngIf="showGiftCardsInformationMessage" class="row justify-content-center">
   <div class="col-12 py-2">
     <p class="infotext container-wrapper">
       {{ 'GiftCardInfoText' | translate }}
     </p>
   </div>
</div>

<div class="col-12 text-center">
  <app-giftcard-custom></app-giftcard-custom>
</div>
